import { CommonModule } from '@angular/common';
import {
  booleanAttribute,
  Directive,
  input,
  InputSignal,
  InputSignalWithTransform,
  signal,
  WritableSignal
} from '@angular/core';

import { Mapper, MapperPipe } from 'tiime-expert-utils';
import { TiimeButtonModule, TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

import { BooleanInputType } from '@modules/core/types/boolean-input.type';

export const CompanyContactsBaseImports = [
  CommonModule,
  TiimeTooltipModule,
  MapperPipe,
  TiimeButtonModule,
  TiimeIconModule
];

@Directive()
export abstract class CompanyContactsBase<T> {
  readonly contacts: InputSignal<T[]> = input<T[]>();
  readonly displayOthersOnClick: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(
    false,
    {
      transform: booleanAttribute
    }
  );
  readonly showPrefix: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly showSuffix: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });

  readonly displayOthers: WritableSignal<boolean> = signal<boolean>(false);

  abstract mapToContactPrefix: Mapper<T, string>;

  abstract mapToContactFullName: Mapper<T, string>;

  abstract mapToContactSuffix: Mapper<T, string>;

  abstract mapToContactTooltip: Mapper<T, string>;

  readonly mapToOtherContacts: Mapper<T[], string> = (contacts: T[]) => {
    const otherContacts: T[] = [...contacts];
    otherContacts.shift();

    return otherContacts
      .map((otherContact: T) => {
        let otherContactValue: string = '';
        if (this.showPrefix()) {
          otherContactValue = otherContactValue.concat(this.mapToContactPrefix(otherContact));
        }

        otherContactValue = this.mapToContactFullName(otherContact);

        if (this.showSuffix()) {
          otherContactValue = otherContactValue.concat(this.mapToContactSuffix(otherContact));
        }

        return otherContactValue;
      })
      .join(', ');
  };

  toggleOthers(): void {
    this.displayOthers.set(!this.displayOthers());
  }
}
